import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status:
    localStorage.getItem('authStatus') === 'authorized'
      ? 'authorized'
      : 'unauthorized',
};

const authorizationSlice = createSlice({
  name: 'enableRoute',
  initialState,
  reducers: {
    setEnable: (state) => {
      state.status = 'authorized';
      localStorage.setItem('authStatus', 'authorized');
    },
    setDisable: (state) => {
      state.status = 'unauthorized';
      localStorage.setItem('authStatus', 'unauthorized');
    },
  },
});

export const { setEnable, setDisable } = authorizationSlice.actions;
export default authorizationSlice.reducer;
